import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';


// Tabs
import TrainingsEditTab from './Elements/TrainingsEditTab';
import TrainingCertificationsTab from './Elements/TrainingCertificationsTab';
import TrainingStaffsTab from './Elements/TrainingStaffsTab';
import TrainingResultsTab from './Elements/TrainingResultsTab';
import TrainingCertificationStaffDailiesTab from './Elements/TrainingCertificationStaffDailiesTab';
import TrainingCertificationStaffPaymentsTab from './Elements/TrainingCertificationStaffPaymentsTab';
import TrainingConfirmationsTab from './Elements/TrainingConfirmationsTab';
import TrainingAlertsTab from './Elements/TrainingAlertsTab';
import TrainingRevisionsTab from './Elements/TrainingRevisionsTab';
import TrainingAvaliationsTab from './Elements/TrainingAvaliationsTab';

const PropTypes = require('prop-types');

class TrainingsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      file: {
        class: '',
        status_str: '',
        status_alt_str: '',
        id: '',
      },
      redirect_url: false,
      errors_listing: false,
      loaded: 0,
      actual_id: this.props.match.params.id,
      key: 1,
      training_data: {},
      certification_groups: {},
      certifications: {},
      staffs_available: {},
      staffs: null,
      countries: null,
      training_certifications: {},
      training_certification_staffs: null,
      training_certification_staff_payments: null,
      training_certification_instructors: null,
      training_revisions_data: null,
      iframe: 'iframe-hidden',
      url_export: null,
      confirmations: null,
      updated: 0,
      alert_files: 0,
      alert_files_str: '',
      exp_type: 'SOLO',
      archive: '',
      modal: false,
      modal_change_status: false,
      modal_email: false,
      modal_available: false,
      alerts: {},
      alerts_log: {},
      files: {},
      emails: '',
      companies_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.openAlertModal = this.openAlertModal.bind(this);
    this.openAvailableModal = this.openAvailableModal.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.closeAlertModalAvailable = this.closeAlertModalAvailable.bind(this);
    this.generatePayment = this.generatePayment.bind(this);
    this.addStaff = this.addStaff.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if((this.state.loaded === 1 && prevState.loaded === 0)) {
      this.setState({actual_id: this.props.match.params.id});
      this.setState({loaded: 2}, this.loadData());
    }
    if((this.props.match.params.id !== this.state.actual_id)) {
      this.handleAlert('', '', 'open');
      this.setState({actual_id: this.props.match.params.id});
      var responseJson = {data: '', status: '', message: ''};
      this.updateData(responseJson);
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/treinamentos');
        if (responseJson.status === 'success') {
          self.setState({training_data: responseJson.data.main});
          self.setState({countries: responseJson.data.countries});
          self.setState({staffs: responseJson.data.staffs});
          self.setState({certifications: responseJson.data.certifications});
          self.setState({certification_groups: responseJson.data.certification_groups});
          self.setState({training_certifications: responseJson.data.training_certifications});
          self.setState({training_certification_staffs: responseJson.data.training_certification_staffs});
          self.setState({training_certification_instructors: responseJson.data.training_certification_instructors});
          self.setState({training_revisions: responseJson.data.training_revisions});
          self.setState({training_certifications_list: responseJson.data.training_certifications_list});
          self.setState({training_certification_staffs_list: responseJson.data.training_certification_staffs_list});
          self.setState({training_avaliation_staffs: responseJson.data.training_avaliation_staffs});
          self.setState({training_certification_staff_payments: responseJson.data.training_certification_staff_payments});
          self.setState({training_certification_staff_dailies: responseJson.data.training_certification_staff_dailies});
       }
      }).then(() => {
        var url = config.get('api_sigtrip') + '/empresas/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ companies_select: responseJson.data });
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          if(event.status == 'error') {
            //Se houver event.data.error
            if(event.data.error) {
              self.setState({errors_listing: true, errors_messages: event.data.message});
            } else {
              self.handleAlert(event.message, event.status, 'open');
            }
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      }); });
    });
  }

  changeStatus(url) {
    this.handleAlert('', '', 'open');
    var confirm = "Tem certeza que gostaria de trocar o status do treinamento?";
    if(url === '/treinamento/' + this.state.training_data.id + '/trocar/status/0') {
      confirm = 'Tem certeza que gostaria de trocar o status do treinamento para cancelado?';
    } else if (url === '/treinamento/' + this.state.training_data.id + '/trocar/status/2') {
      confirm = 'Tem certeza que gostaria de trocar o status do treinamento para divulgado?';
    }
    if (window.confirm(confirm)) {
      var datasave = {};
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openAvailableModal() {
    this.handleAlert('', '', 'open');
    var datasave = {};
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/colaboradores/elegiveis/' + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          modal_available: true,
          staffs_available: responseJson.data,
        });
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openAlertModal() {
    this.handleAlert('', '', 'open');
    var datasave = {};
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/alertas/' + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          modal: true,
          alerts: responseJson.data,
        });
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  closeAlertModal() {
    this.setState({
      modal: false,
      alerts: {},
    });
  }

  changePresence() {
    this.setState({
      attendence: true,
    });
  }

  closeAlertModalAvailable() {
    this.setState({
      modal_available: false,
      staffs_available: {},
    });
  }

  generatePayment() {
    var confirm = window.confirm('Tem certeza que gostaria de gerar os pagamentos dos alunos de presença confirmada deste treinamento?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {};
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/gerar/pagamento/' + self.props.match.params.id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch salvando a edição
  addStaff(staff_id) {
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_id: staff_id,
      training_id: this.state.training_data.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificados/colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.updateData(responseJson);
        self.closeAlertModalAvailable();
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />

  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de treinamento</h3>
      {/* Botão de fichas */}
      <div className="grid-buttons pull-right">
        <button  className="btn btn-primary" onClick={self.openAvailableModal}><i className="fa fa-user"></i> {"Colaboradores elegíveis"}</button>
        {(this.state.training_data.status === 2 || this.state.training_data.status === 4) ?
          <button className="btn btn-success" onClick={this.generatePayment}><i className="fa fa-dollar"></i> Confirmar pagamentos</button>
          :
          ''
        }
        <Dropdown id="revisions">
          <Dropdown.Toggle bsStyle={'info'}>
            <i className="fa fa-fw fa-certificate"></i> {this.state.training_data.status_str}
          </Dropdown.Toggle>
            {(this.state.training_data.status === 1 || this.state.training_data.status === 3) ?
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/2'}>Trocar para Divulgado</MenuItem>
                <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>Trocar para Cancelado</MenuItem>
              </Dropdown.Menu>
            :
              (this.state.training_data.status === 2) ?
                <Dropdown.Menu className="super-colors">
                  <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/4'}>Trocar para Finalizado</MenuItem>
                  <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>Trocar para Cancelado</MenuItem>
                </Dropdown.Menu>
              :
                (this.state.training_data.status === 3) ?
                  <Dropdown.Menu className="super-colors">
                    <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>Cancelado</MenuItem>
                  </Dropdown.Menu>
                :
                  <Dropdown.Menu className="super-colors">
                    <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>Cancelado</MenuItem>
                  </Dropdown.Menu>
            }
        </Dropdown>
        <button  className="btn btn-warning" onClick={self.openAlertModal}><i className="fa fa-warning"></i> Alertas</button>
        <Link to="/treinamentos" className="btn btn-default"><i className="fa fa-chevron-left"></i> Voltar</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      {this.state.errors_listing &&
          <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
            <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <strong>Erros ao adicionar aluno(s):</strong>
            {Object.keys(self.state.errors_messages).map(function(k) {
              var message = self.state.errors_messages[k];
              return (
                <p>- {message}</p>
              );
            })}
          </div>
      }
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados do treinamento">
          <TrainingsEditTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} countries={this.state.countries} companies_select={this.state.companies_select} />
        </Tab>
        <Tab eventKey={2} title="Aulas">
          <TrainingCertificationsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} certifications={this.state.certifications} training_certifications={this.state.training_certifications} staffs={this.state.staffs} certification_groups={this.state.certification_groups} />
        </Tab>
        <Tab eventKey={3} title="Alunos">
          <TrainingStaffsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certification_staffs={this.state.training_certification_staffs} staffs={this.state.staffs} />
        </Tab>
        <Tab eventKey={4} title="Diárias">
          <TrainingCertificationStaffPaymentsTab status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_certification_staff_payments={this.state.training_certification_staff_payments} />
        </Tab>
        {(this.state.training_data.status === 4) ?
        <Tab eventKey={7} title="Resultados">

          <TrainingResultsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certification_staffs={this.state.training_certification_staffs} training_certification_instructors={this.state.training_certification_instructors} staffs={this.state.staffs} verify_finalized={this.state.verify_finalized} />

        </Tab>
        :
          ''
        }
        {(this.state.training_data.status === 4) ?
        <Tab eventKey={8} title={"Registros"}>

          <TrainingCertificationStaffDailiesTab handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_certification_staff_dailies={this.state.training_certification_staff_dailies} />

        </Tab>
        :
          ''
        }
        <Tab eventKey={9} title="Revisão">
          <TrainingRevisionsTab handleAlert={this.handleAlert} status={this.state.training_data.status} training_id={this.props.match.params.id} training_revisions={this.state.training_revisions} verify_revision_opened={this.state.verify_revision_opened} training_status={this.state.training_data.status} />
        </Tab>
      {
        <Tab eventKey={10} title="Avaliações">
          <TrainingAvaliationsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_avaliation_staffs={this.state.training_avaliation_staffs} training_certifications_list={this.state.training_certifications_list} training_certification_staffs_list={this.state.training_certification_staffs_list} />
        </Tab>
          /*
        <Tab eventKey={3} title="Alunos">
          <TrainingStaffsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certification_staffs={this.state.training_certification_staffs} staff_available_list={this.state.staff_available_list} />
        </Tab>
        <Tab eventKey={4} title="Diárias">
          <TrainingCertificationStaffPaymentsTab status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_certification_staff_payments={this.state.training_certification_staff_payments} />
        </Tab>
        {(this.state.training_data.status !== 1 && this.state.training_data.status !== 3) ?
        <Tab eventKey={5} title="Presença">
          <TrainingConfirmationsTab status={this.state.training_data.status} updated={this.state.updated} updateData={this.updateData} handleAlert={this.handleAlert} training_id={this.props.match.params.id} confirmations={this.state.confirmations} verify_confirmations={this.state.verify_confirmations} />
        </Tab>
        :
          ''
        }
        {(this.state.training_data.status === 2) ?
        <Tab eventKey={6} title="Alertas">
          <TrainingAlertsTab status={this.state.training_data.status} updated={this.state.updated} updateData={this.updateData} handleAlert={this.handleAlert} training_id={this.props.match.params.id} alerts={this.state.alerts_log} />
        </Tab>
        :
          ''
        }

           */
      }
      </Tabs>
    </div>
  </div>
  <Modal show={this.state.modal_available} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{"Colaboradores Elegiveis"}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModalAvailable}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>{"Tripulante"}</th>
            <th>{"Certificado"}</th>
            <th>{"DataDeExpiracao"}</th>
            <th>{"Prazo"}</th>
            <th className="col-md-2">{"Acoes"}</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(self.state.staffs_available).map(function(k) {
            return (
              <tr>
                <td>{self.state.staffs_available[k].staff.name}</td>
                <td>{self.state.staffs_available[k].certification.name}</td>
                <td>{self.state.staffs_available[k].expire_str}</td>
                <td>{self.state.staffs_available[k].deadline}</td>
                <td>
                  {(self.state.training_data.status === 1 || self.state.training_data.status === 3) ?
                    <button className="btn btn-success btn-block" onClick={() => (self.addStaff(self.state.staffs_available[k].staff_id))}><i className="fa fa-plus"></i> {"Adicionar"}</button>
                    :
                    ''
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModalAvailable}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  {

  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Informativo de alertas</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {Object.keys(self.state.alerts).map(function(name) {
        var tcs = self.state.alerts[name];
        return (
          <div>
            <h4 className='crew-background-style'><strong>{name}</strong></h4>
            {Object.keys(tcs).map(function(certification) {
              var alert = tcs[certification];
              if (alert.status === 'error') {
                return (
                  <div className={"box-alert box-alert-" + alert.color} dangerouslySetInnerHTML={{__html: alert.message}}></div>
                );
              }
              return ('');
            })}
            <hr/>
          </div>
        );
      })}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  }
</div>
    );
  }
}

TrainingsEdit.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default TrainingsEdit;



// WEBPACK FOOTER //
// ./src/Components/Trainings/TrainingsEdit.js